export default "__VITE_ASSET__CPF8tC6s__"